/** Утилиты для iOS Safari / standalone PWA. */

export function isIosDevice() {
  if (typeof navigator === 'undefined') return false;
  return (
    /iPad|iPhone|iPod/.test(navigator.userAgent)
    || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  );
}

export function isMobileTabViewport() {
  if (typeof window === 'undefined') return false;
  return window.matchMedia('(max-width: 767px)').matches;
}

export function resetIosPageScroll() {
  if (!isIosDevice()) return;
  const vv = window.visualViewport;
  if (vv) {
    if (window.scrollY !== 0 || vv.offsetTop !== 0) {
      window.scrollTo(0, 0);
    }
    return;
  }
  if (window.scrollY !== 0) {
    window.scrollTo(0, 0);
  }
}
